export const EXCLUDED_CONFIG_IDS = [
    'stripe-dashboard',
    'lemon-squeezy-dashboard',
    'gmail',
]
